import React, { useState, useCallback, useRef } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFarsi = n => n === null || n === undefined ? '' : String(n).replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
const toEng   = s => String(s).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());

const EVENT_TYPES = [
  { val: 0, label: '— انتخاب کنید —' }, { val: 1, label: 'استحقاقی' }, { val: 2, label: 'استعلاجی' },
  { val: 3, label: 'بدون حقوق' }, { val: 4, label: 'زایمان' }, { val: 5, label: 'تشویقی' },
  { val: 6, label: 'اضطراری' }, { val: 7, label: 'ساعتی' }, { val: 8, label: 'سایر' },
];

const EMPTY_FORM = {
  event_type: 0, event_no: '', event_date: '', start_date: '', end_date: '',
  duration_days: '', duration_hours: '', description: '', serv_record: '',
};

const API = (path, opts = {}) =>
  fetch(`/api/accounting${path}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
    ...opts,
  }).then(jsonOf, netErr);

const FInput = ({ label, name, value, onChange, readOnly, half, note }) => (
  <div style={{ display:'flex', flexDirection:'column', gap:'4px', flex: half ? '0 0 48%' : '1' }}>
    <label style={ui.mlabel}>{label}</label>
    <input name={name} value={value} onChange={onChange} readOnly={readOnly}
      style={{ ...ui.input, background: readOnly ? '#f5f5f5' : '#fff', color: readOnly ? '#888' : '#111', cursor: readOnly ? 'not-allowed' : 'text', direction:'rtl' }} />
    {note && <span style={{ fontSize:'11px', color:'#999' }}>{note}</span>}
  </div>
);
const FSelect = ({ label, name, value, onChange, opts }) => (
  <div style={{ display:'flex', flexDirection:'column', gap:'4px', flex:1 }}>
    <label style={ui.mlabel}>{label}</label>
    <select name={name} value={value} onChange={onChange} style={ui.input}>
      {opts.map(o => <option key={o.val} value={o.val}>{o.label}</option>)}
    </select>
  </div>
);
const FDatePicker = ({ label, value, onChange, half }) => (
  <div style={{ display:'flex', flexDirection:'column', gap:'4px', flex: half ? '0 0 48%' : '1' }}>
    <label style={ui.mlabel}>{label}</label>
    <JalaliDatePicker value={value} onChange={onChange} placeholder="انتخاب تاریخ" />
  </div>
);

export default function AccountingLeave({ user, onBack }) {
  // دکمه‌های فرم FRMLEAVE؛ دیدن = دسترسی
  const vbf = useFormButtons('FRMLEAVE', ["BTNNEW","BTNEDIT","BTNDELETE","BTNOK"]);
  const [melliCode,  setMelliCode]  = useState('');
  const [fullName,   setFullName]   = useState('');
  const [year, setYear] = useState(() => toEng(new Date().toLocaleDateString('fa-IR').split('/')[0]));
  const [remain,     setRemain]     = useState(0);
  const [data,       setData]       = useState([]);
  const [selected,   setSelected]   = useState(null);
  const [loading,    setLoading]    = useState(false);
  const [modal,      setModal]      = useState(null);
  const [form,       setForm]       = useState(EMPTY_FORM);
  const [saving,     setSaving]     = useState(false);
  const [error,      setError]      = useState('');
  const [toast,      setToast]      = useState('');
  const [lookupMsg,  setLookupMsg]  = useState('');
  const lookupTimer = useRef(null);

  const showToast = msg => { setToast(msg); setTimeout(() => setToast(''), 3000); };

  const load = useCallback(async (mc = melliCode, y = year) => {
    if (!mc || mc.length < 10 || !y || y.length !== 4) return;
    setLoading(true); setError('');
    const j = await API(`/leave/?melli_code=${encodeURIComponent(mc)}&year=${y}`);
    setLoading(false);
    if (j.ok) { setData(j.data); if (j.full_name) setFullName(j.full_name); setRemain(j.remain || 0); if (j.msg) setLookupMsg(j.msg); }
    else setError(j.msg);
  }, [melliCode, year]);

  const handleMelliChange = async e => {
    const val = toEng(e.target.value).replace(/\D/g, '').slice(0, 10);
    setMelliCode(val); setFullName(''); setLookupMsg(''); setData([]); setSelected(null);
    if (lookupTimer.current) clearTimeout(lookupTimer.current);
    if (val.length === 10) {
      lookupTimer.current = setTimeout(async () => {
        const j = await API(`/leave/lookup/?melli_code=${val}`);
        if (j.ok) setFullName(`${j.first_name} ${j.last_name}`.trim());
        else setLookupMsg(j.msg || 'کد ملی یافت نشد');
      }, 300);
    }
  };
  const handleYearChange = e => {
    const val = toEng(e.target.value).replace(/\D/g, '').slice(0, 4);
    setYear(val);
    if (val.length === 4 && melliCode.length === 10) load(melliCode, val);
  };
  const handleFormChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: name === 'event_type' ? Number(value) : value }));
  };

  const openNew = () => { if (!vbf.can('BTNNEW')) return;
    if (!melliCode || melliCode.length < 10) { setError('ابتدا کد ملی را وارد کنید'); return; }
    setForm(EMPTY_FORM); setError(''); setModal('new');
  };
  const openEdit = () => { if (!vbf.can('BTNEDIT')) return;
    if (!selected) return;
    setForm({
      event_type: selected.event_type, event_no: selected.event_no, event_date: selected.event_date,
      start_date: selected.start_date, end_date: selected.end_date,
      duration_days: String(selected.duration_days || ''), duration_hours: String(selected.duration_hours || ''),
      description: selected.description, serv_record: selected.serv_record,
    });
    setError(''); setModal('edit');
  };
  const openDelete = () => { if (!vbf.can('BTNDELETE')) return; if (!selected) return; setError(''); setModal('delete'); };

  const save = async () => {
    if (!form.event_type) { setError('نوع مرخصی الزامی است'); return; }
    if (!form.start_date) { setError('تاریخ شروع الزامی است'); return; }
    setSaving(true); setError('');
    const payload = { ...form,
      duration_days:  Number(toEng(String(form.duration_days)))  || 0,
      duration_hours: Number(toEng(String(form.duration_hours))) || 0,
      melli_code: melliCode, financial_year: year };
    const j = modal === 'new'
      ? await API('/leave/create/', { method:'POST', body: JSON.stringify(payload) })
      : await API(`/leave/${selected.id}/update/`, { method:'PUT', body: JSON.stringify(payload) });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast(j.msg); load(); }
    else setError(j.msg);
  };
  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/leave/${selected.id}/delete/`, { method:'DELETE' });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('رکورد حذف شد'); load(); }
    else { setError(j.msg); setModal('delete_blocked'); }
  };

  const toolbar = (
    <div style={{ display:'flex', alignItems:'flex-end', gap:'12px', width:'100%', flexWrap:'wrap' }}>
      <div style={{ ...ui.toolBtns, alignItems:'center' }}>
        {vbf.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected?1:0.4, cursor: selected?'pointer':'default' }}>✎ ویرایش</button>}
        {vbf.can('BTNDELETE') && <button onClick={openDelete} disabled={!selected} style={{ ...ui.btnDel, opacity: selected?1:0.4, cursor: selected?'pointer':'default' }}>✕ حذف</button>}
      </div>
      <div style={{ display:'flex', flexDirection:'column', gap:'2px' }}>
        <label style={ui.flabel}>کد ملی</label>
        <input value={toFarsi(melliCode)} onChange={handleMelliChange} onKeyDown={e => e.key==='Enter' && melliCode.length>=8 && load()}
          maxLength={10} placeholder="۱۰ رقم" style={filterInput} />
      </div>
      <div style={{ display:'flex', flexDirection:'column', gap:'2px', flex:1, minWidth:'160px' }}>
        <label style={ui.flabel}>نام و نام خانوادگی</label>
        <input value={fullName} readOnly tabIndex={-1}
          style={{ ...filterInput, minWidth:'160px', background: fullName ? '#fffde7' : '#f5f5f5', border: fullName ? '1.5px solid #f9a825' : '1.5px solid #e0e0e0', cursor:'not-allowed' }} />
        {lookupMsg && <span style={{ fontSize:'11px', color:'#c62828' }}>⚠️ {lookupMsg}</span>}
      </div>
      <div style={{ display:'flex', flexDirection:'column', gap:'2px' }}>
        <label style={ui.flabel}>سال مالی</label>
        <input value={toFarsi(year)} onChange={handleYearChange} maxLength={4} placeholder="۱۴۰۵" style={{ ...filterInput, width:'90px', textAlign:'right', direction:'rtl' }} />
      </div>
      <button onClick={() => load()} disabled={melliCode.length<8||year.length!==4||loading}
        style={{ padding:'9px 18px', background:'linear-gradient(135deg,#006064,#00838f)', color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer', fontFamily:'inherit', fontSize:'13px', fontWeight:'700', whiteSpace:'nowrap', opacity: melliCode.length>=8&&year.length===4?1:0.4 }}>
        {loading ? '⏳' : '🔍 جستجو'}
      </button>
      {data.length > 0 && <div style={{ padding:'6px 14px', background:'#e8f5e9', color:'#1b5e20', borderRadius:'20px', fontSize:'12px', fontWeight:'700', border:'1px solid #a5d6a7', whiteSpace:'nowrap', alignSelf:'flex-end' }}>مانده: <strong>{toFarsi(remain)}</strong> روز</div>}
      {data.length > 0 && <div style={{ ...ui.countBadge, alignSelf:'flex-end' }}>{toFarsi(data.length)} رکورد</div>}
    </div>
  );

  return (
    <>
      <ListPage user={user} onBack={onBack} title="مرخصی کارکنان" subtitle="تنظیم حساب — سامانه ارجان"
        toolbar={toolbar} error={!modal ? error : ''}>
        <table style={ui.table}>
          <thead style={{ position:'sticky', top:0, zIndex:10 }}>
            <tr>
              <th style={{ ...ui.th, textAlign:'right', minWidth:'130px' }}>نام و نام خانوادگی</th>
              <th style={{ ...ui.th, minWidth:'90px' }}>نوع مرخصی</th>
              <th style={{ ...ui.th, minWidth:'95px' }}>تاریخ شروع</th>
              <th style={{ ...ui.th, minWidth:'95px' }}>تاریخ پایان</th>
              <th style={{ ...ui.th, width:'55px' }}>روز</th>
              <th style={{ ...ui.th, width:'55px' }}>ساعت</th>
              <th style={{ ...ui.th, width:'75px', fontSize:'11px' }}>شماره رویداد</th>
              <th style={{ ...ui.th, width:'95px', fontSize:'11px' }}>تاریخ رویداد</th>
              <th style={{ ...ui.th, width:'70px', background:'#0d2137', color:'#C8A84B', fontSize:'11px' }}>مانده</th>
              <th style={{ ...ui.th, width:'70px', fontSize:'11px' }}>مجموع</th>
              <th style={{ ...ui.th, width:'80px', fontSize:'11px' }}>سنوات</th>
              <th style={{ ...ui.th, textAlign:'right', minWidth:'120px' }}>توضیحات</th>
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => {
              const sel = selected?.id === r.id;
              const bg  = sel ? '#1a2f50' : i%2===0 ? '#fff' : '#fdf6e3';
              const tc  = sel ? '#fff' : '#111';
              return (
                <tr key={r.id} style={{ background:bg, cursor:'pointer', transition:'background 0.1s' }}
                  onClick={() => setSelected(sel ? null : r)}
                  onMouseEnter={e => { if (!sel) e.currentTarget.style.background='#e8f0fe'; }}
                  onMouseLeave={e => { if (!sel) e.currentTarget.style.background=bg; }}>
                  <td style={{ ...ui.td, textAlign:'right', fontWeight:'600', color: sel?'#C8A84B':'#1a237e' }}>{r.full_name}</td>
                  <td style={{ ...ui.td, color:tc }}>{r.event_type_name}</td>
                  <td style={{ ...ui.td, fontFamily:'monospace', color:tc }}>{r.start_date}</td>
                  <td style={{ ...ui.td, fontFamily:'monospace', color:tc }}>{r.end_date}</td>
                  <td style={{ ...ui.td, fontWeight:'700', color: sel?'#81c784':'#1b5e20' }}>{r.duration_days > 0 ? toFarsi(r.duration_days) : '—'}</td>
                  <td style={{ ...ui.td, color:tc }}>{r.duration_hours > 0 ? toFarsi(r.duration_hours) : '—'}</td>
                  <td style={{ ...ui.td, fontSize:'11px', color:tc }}>{r.event_no || '—'}</td>
                  <td style={{ ...ui.td, fontFamily:'monospace', fontSize:'11px', color:tc }}>{r.event_date || '—'}</td>
                  <td style={{ ...ui.td, fontWeight:'700', color: sel?'#ffb74d':r.remained_leave_sum>0?'#b71c1c':'#999' }}>{r.remained_leave_sum > 0 ? toFarsi(r.remained_leave_sum) : '—'}</td>
                  <td style={{ ...ui.td, color:tc }}>{r.leave_sum > 0 ? toFarsi(r.leave_sum) : '—'}</td>
                  <td style={{ ...ui.td, fontSize:'11px', color:tc }}>{r.serv_record || '—'}</td>
                  <td style={{ ...ui.td, textAlign:'right', fontSize:'11px', color: sel?'rgba(255,255,255,0.8)':'#555', maxWidth:'140px', overflow:'hidden', textOverflow:'ellipsis' }} title={r.description}>{r.description || ''}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!loading && data.length===0 && melliCode.length>=10 && <div style={ui.empty}>📭 رکوردی برای این کارمند در سال {toFarsi(year)} یافت نشد</div>}
        {!melliCode && <div style={ui.empty}>🔍 ابتدا کد ملی کارمند را وارد کنید</div>}
      </ListPage>

      {(modal==='new' || modal==='edit') && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth:'620px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal==='new' ? '＋ مرخصی جدید' : '✎ ویرایش مرخصی'}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}
              <div style={{ display:'flex', alignItems:'center', flexWrap:'wrap', background:'#f0f4ff', border:'1px solid #c5cae9', borderRadius:'8px', padding:'10px 14px', marginBottom:'16px' }}>
                <span style={{ fontSize:'13px', fontWeight:'700', color:'#1a237e' }}>{fullName||'—'}</span>
                <span style={{ fontSize:'12px', color:'#888', marginRight:'12px' }}>کد ملی: {toFarsi(melliCode)}</span>
                <span style={{ fontSize:'12px', color:'#888', marginRight:'12px' }}>سال: {toFarsi(year)}</span>
              </div>
              <div style={ui.row}><FSelect label="نوع مرخصی *" name="event_type" value={form.event_type} onChange={handleFormChange} opts={EVENT_TYPES} /></div>
              <div style={ui.row}>
                <FDatePicker label="تاریخ شروع *" value={form.start_date} onChange={v => setForm(f=>({...f, start_date:v}))} half />
                <FDatePicker label="تاریخ پایان" value={form.end_date} onChange={v => setForm(f=>({...f, end_date:v}))} half />
              </div>
              <div style={ui.row}>
                <FInput label="روز" name="duration_days" value={form.duration_days} onChange={handleFormChange} half />
                <FInput label="ساعت" name="duration_hours" value={form.duration_hours} onChange={handleFormChange} half />
              </div>
              <div style={ui.divider} />
              <div style={ui.row}>
                <FInput label="شماره برخواست" name="event_no" value={form.event_no} onChange={handleFormChange} half />
                <FDatePicker label="تاریخ برخواست" value={form.event_date} onChange={v => setForm(f=>({...f, event_date:v}))} half />
              </div>
              <div style={ui.row}><FInput label="سنوات (yy/mm/dd)" name="serv_record" value={form.serv_record} onChange={handleFormChange} note="مثلاً ۲۵/۰۶/۱۵" half /></div>
              <div style={ui.divider} />
              <div style={{ display:'flex', flexDirection:'column', gap:'4px' }}>
                <label style={ui.mlabel}>توضیحات</label>
                <textarea name="description" value={form.description} onChange={handleFormChange} rows={3}
                  style={{ padding:'8px 12px', border:'1.5px solid #e0e0e0', borderRadius:'8px', fontSize:'13px', fontFamily:"'Vazirmatn',Tahoma,sans-serif", outline:'none', resize:'vertical', direction:'rtl' }} />
              </div>
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ در حال ذخیره...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal==='delete' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth:'460px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background:'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={ui.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign:'center', padding:'28px' }}>
              <div style={{ fontSize:'36px', marginBottom:'12px' }}>🗑️</div>
              <div style={{ fontSize:'15px', fontWeight:'700', color:'#1a2f50', marginBottom:'8px' }}>آیا مطمئن هستید؟</div>
              <div style={{ background:'#fff3f3', border:'1px solid #ffcdd2', borderRadius:'8px', padding:'10px 14px', marginTop:'10px', fontWeight:'700', color:'#b71c1c' }}>
                {selected?.event_type_name} | {selected?.start_date} تا {selected?.end_date}
              </div>
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setModal(null)} style={ui.btnCancel}>خیر، انصراف</button>
              {vbf.can('BTNDELETE') && <button onClick={doDelete} disabled={saving} style={{ ...ui.btnSave, background:'#b71c1c' }}>{saving ? '⏳...' : 'بله، حذف شود'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal==='delete_blocked' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth:'420px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background:'linear-gradient(135deg,#e65100,#f57c00)' }}>
              <div style={ui.mTitle}>🚫 عدم امکان حذف</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign:'center', padding:'28px', fontSize:'14px', color:'#1a2f50', fontWeight:'700' }}>{error}</div>
            <div style={ui.mFooter}><button onClick={() => { setModal(null); setError(''); }} style={ui.btnSave}>باشه</button></div>
          </div>
        </div>
      )}

      {toast && <div style={ui.toast}>{toast}</div>}
    </>
  );
}

const filterInput = { padding:'8px 12px', border:'1.5px solid #e0e0e0', borderRadius:'8px', fontSize:'13px', fontFamily:"'Vazirmatn',Tahoma,sans-serif", outline:'none', direction:'rtl', textAlign:'right' };
